import { JsonObject, JsonProperty } from 'json2typescript';
import { User } from '../users/user';


@JsonObject('Service')
export class Service {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('name_ar', String, true)
    nameAr = '';

    @JsonProperty('level', Number)
    level = undefined;

    @JsonProperty('code', String)
    code = '';

    get displayName() {
        return `${this.name} - ${this.nameAr}`;
    }
}

